import React from 'react';
import { Helmet } from 'react-helmet';

function GamesPreview_() {
    const searchParams = new URLSearchParams(window.location.search);
    const gameName = searchParams.get('name');
    
    // Get the full query string and extract the game URL
    // For Gamezop: /games?https://...&name=GameName
    // For GamePix: /games?https://...&name=GameName
    const fullQuery = window.location.search.substring(1); // Remove '?'
    const nameIndex = fullQuery.indexOf('&name=');
    const gameUrl = nameIndex !== -1 ? fullQuery.substring(0, nameIndex) : fullQuery;

    return (
        <div>
            <Helmet>
                <title>{`Play ${gameName || 'Game'} Online | vibeofgames – Free Online Games`}</title>
                <meta name="description" content={`Play ${gameName || 'this game'} free online at vibeofgames. No downloads needed!`} />
                <meta name="keywords" content={`play ${gameName} online, free ${gameName} game, online games, vibeofgames`} />
                <meta property="og:title" content={`Play ${gameName} Online | vibeofgames`} />
                <meta property="og:description" content={`Play ${gameName} free online at vibeofgames`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <iframe 
                src={gameUrl} 
                title={gameName || 'game'} 
                allow="autoplay; fullscreen" 
                className="w-screen h-screen border-0 block" 
            />
        </div>
    );
}

export default GamesPreview_;
